import { marked, Renderer, setOptions } from 'marked';
import sanitizeHtml from 'sanitize-html';

const renderer = new Renderer();

const defaultOpts = {
    tables: true,
    breaks: true,
    smartypants: false,
};

// Capture the original link renderer method
const linkRenderer = renderer.link;
renderer.link = function (link) {
    const html = linkRenderer.call(this, link);
    return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
};

export default function parseMarkdown(string: string, opts = {}) {
    if (!string) return;

    setOptions({
        ...defaultOpts,
        ...opts,
    });


    return sanitizeHtml(marked(string, { renderer }));
}
